import React, { useState, useEffect, useRef } from "react";
import AllRounder from "../Assests/Images/Badges/AllRounder.svg";
import Excelent from "../Assests/Images/Badges/Excellent.svg";
import Goddone from "../Assests/Images/Badges/Goodone.svg";
import ThreeAssessmnets from "../Assests/Images/Badges/3Assessments.svg";
import AllAssessments from "../Assests/Images/Badges/6Assessments.svg";
import { IoMdDownload } from "react-icons/io";
import "../Assests/Scss/Badges.scss";
import CopyRight from "../Reusablecomponents/Copyright";
import InternetChecking from "../Reusablecomponents/Network";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { useSelector } from "react-redux";
import axiosInstance from "../../ReusableComponents/Axios";
import { DownloadGraphImage, DownloadHTMlcodeimage } from "../../ReusableComponents/CommonFunctions";
import { DownloadGraphButton } from "../../ReusableComponents/CommonComponents";

const BadgeDetails = () => {
    const BadgeRef = useRef();
    const items = useSelector((state) => state.userDetailsData.LoginDetails);
    const USYear = useSelector((state) => state.SelecYearData.SYear);

    const [ViewBadge, CloseBadge] = useState();
    const [StoreBadges, SetStoreBadges] = useState();

    const GetBadges = async () => {
        // SetLoad((prev) => !prev);
        try {
            const response = await axiosInstance.get(`/StudentResults/StudentsMyRewardsSection?UserId=${items?.userId}&Year=${USYear?.value}`);
            if (response.data?.filter((item) => item.isStudentAttended === 1).length > 0) {
                SetStoreBadges(response.data);
            } else {
                SetStoreBadges(process.env.REACT_APP_NODATAFOUND_Participated);
            }
            // SetLoad((prev) => !prev);
        } catch (error) {
            console.error(error);
        }
    }
    useEffect(() => { GetBadges(); }, [USYear])
    const BadgesImg = (Score) => {
        if (StoreBadges) {

            switch (true) {
                case Score === 100:
                    return ["All Rounder", AllRounder];
                case Score >= 80 && Score <= 99:
                    return ["Excellent", Excelent];
                case Score >= 60 && Score <= 79:
                    return ["Good one", Goddone];
                default:
                    return "";
            }
        }
    };
    const DownloadBadge = (e) => {
        DownloadHTMlcodeimage(BadgeRef, e);
        //   DownloadGraphImage(BadgeRef, e);
    };
    return (<>
        <div className="VASheet Instructions-pages">
            <InternetChecking />
            <div className="Vtitle"> <h5>Hi, {items?.fullName}” See what you Achieve!</h5> </div>
            {StoreBadges?.[0].assessmentTypeNo ? <>
                <div className="Badges-SubTitle mt-3 mb-2" >Performance Badges</div>
                <div className="dflex gap-3" style={{ display: "grid", gridTemplateColumns: "repeat(6,auto)" }}>

                    {StoreBadges?.filter((item) => item.isStudentAttended === 1).map((Badge) => (
                        <div className="Card Badge-Card dflex alignitems  flexd-column gap-2">
                            <div>{Badge?.assessmentTypeNo} </div>
                            <div>{BadgesImg(Badge?.totalPercentage)?.[0]} </div>
                            <img src={BadgesImg(Badge?.totalPercentage)?.[1]} alt={BadgesImg(Badge?.totalPercentage)?.[0]} />
                            {BadgesImg(Badge?.totalPercentage)?.[0] && <div className="dflex  gap-5"><div></div><div className="CPointer" onClick={() => CloseBadge(BadgesImg(Badge?.totalPercentage))}>View Badge</div> <div></div> {/*<IoMdDownload />*/}</div>}
                        </div>
                    ))}
                </div>
                {(StoreBadges?.[0]?.lastSixAssessment === 1 || StoreBadges?.[0]?.lastThreeAssessment === 1) && <>

                    <div className="Badges-SubTitle mt-3 mb-2" >Participation Badges</div>
                    <div className="dflex gap-3">
                        {StoreBadges?.[0]?.lastSixAssessment === 1 && <div className="Card Badge-Card dflex alignitems  flexd-column gap-2">
                            <div>Participation in all the 6 assessments </div>
                            <div>All Star Assesment </div>
                            <img src={AllAssessments} alt="AllAssessments" />
                            <div className="dflex  gap-5"><div></div><div className="CPointer" onClick={() => CloseBadge(["Participation in all the 6 assessments",AllAssessments])}>View Badge</div> <div></div> {/*<IoMdDownload />*/}</div>
                        </div>}
                        {StoreBadges?.[0]?.lastThreeAssessment === 1 && <div className="Card Badge-Card dflex alignitems  flexd-column gap-2">
                            <div>Participation in 3 assessments in a row </div>
                            <div>Steady Rock star </div>
                            <img src={ThreeAssessmnets} alt="ThreeAssessmnets" />
                            <div className="dflex  gap-5"><div></div><div className="CPointer" onClick={() => CloseBadge(["Participation in 3 assessments in a row",ThreeAssessmnets])}>View Badge</div><div></div> {/*<IoMdDownload  onClick={()=>DownloadGraphImage(BadgeRef,"sample")}/>*/}</div>
                        </div>}
                    </div></>}
            </> : <div className="dflex JCCenter">{StoreBadges}</div>}
            <CopyRight />
        </div>

        {ViewBadge && <div className="Model-Open dflex flexd-column">
            <div className="h-100" style={{ position: "relative" }}>
                <div className="dflex JSBetween">
                    <div></div>
                    <IoMdCloseCircleOutline className="CPointer" style={{ backgroundColor: "white", fontSize: "20px" }} onClick={() => CloseBadge()} /></div>
                <div className="Instructions-pages View-Badge" ref={BadgeRef}>
                    <div className="w-100 h-50 Badge-Header">
                    </div>
                    <div className="Badge-Content dflex flexd-column alignitems">
                        <img src={ViewBadge[1]} alt="ViewBadge" />
                        {/* <div>Congratulations ! </div>
                    <span>You have scored great in English, Maths, Science</span> */}
                    </div>
                </div>
                <div className="dflex JSBetween" style={{ position: "relative", top: "-15%", right: "3%" }} >
                    <div></div>
                    <DownloadGraphButton Click={() => DownloadBadge(ViewBadge[0])} /></div>
            </div>
        </div>}

    </>)
}
export default BadgeDetails;